import * as angular from 'angular';

function filterFunction($filter: ng.IFilterService) {
    return function join(array: any[], separator: string, prop: string) {
        if (!Array.isArray(array)) {
            return array;
        }
        return (prop ? array.map(item => item[prop]) : array).join(separator);
    };
}

angular.module('app.common').filter('join', ['$filter', filterFunction]);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/filters/join.filter.ts